<template>
	<div
		class="full-width my-auto pt-4 d-flex justify-center align-center self-center full-width"
	>
		<div class="allCenteredChild max-w-fit-content pt-4">
			<img
				src="../../assets/orange-badge.png"
				height="56px"
				alt="orangeBadge"
				class="max-w-fit-content"
			/>
			<span class="pos-abs white--text font-weight-bold body-1">
				{{ this.bonusData.active.payout }}
			</span>
		</div>
		<div
			class="full-width d-flex align-center flex-column align-self-baseline mx-3"
		>
			<div class="text-center body-2 grey--text text--darken">
				Customers({{ bonusData.isGmvTarget ? "GMV" : "TS" }}>={{
					this.bonusData.customerLimit
				}})
			</div>
			<div class="amt-text pb-1">
				{{ this.bonusData.currentActiveCustomers }}
			</div>
			<div class="progress-bar">
				<div :style="`width: ${progress}%`" />
			</div>
		</div>
		<div class="allCenteredChild max-w-fit-content pt-4">
			<img
				src="../../assets/blue-badge.png"
				height="56px"
				alt="blueBadge"
				class="max-w-fit-content"
			/>
			<span class="pos-abs white--text font-weight-bold body-1">
				{{ this.bonusData.next.payout }}
			</span>
		</div>
	</div>
</template>
<script>
export default {
	name: "BonusTargetBanner",
	props: ["bonusData"],
	data() {
		return {
			progress: 42
		};
	},
	methods: {
		saveBonusData() {
			const activeCutomers = this.bonusData.active.activeCustomers;
			const nextCutomers = this.bonusData.next.activeCustomers;
			this.progress = Math.min(
				((this.bonusData.currentActiveCustomers - activeCutomers) *
					100) /
					(nextCutomers - activeCutomers),
				100
			);
		}
	},
	mounted() {
		this.saveBonusData();
	}
};
</script>
<style scoped>
.max-w-fit-content {
	max-width: fit-content;
}
.amt-text {
	font-size: 18px;
	font-weight: bold;
	color: #18c9b9;
}
.progress-bar {
	background-color: #e1e4ec;
	border-radius: 4px;
	width: 100%;
}
.progress-bar > div {
	background: linear-gradient(90deg, #12e9b5 0%, #295cc5 100%),
		linear-gradient(270deg, #26a67b 0%, #75efc6 100%);
	height: 8px;
	border-radius: 4px;
}
</style>
